import { setAlertModal, setLoading } from "./app";
import { genericError } from "../../constants/messages";
import axiosInstance from "../../utilities/interceptorUtilities";

export const SET_USER = "SET_USER";
export const SET_AGENT = "SET_AGENT";
export const AUTHENTICATE_AGENT = "AUTHENTICATE_AGENT";
export const AUTHENTICATE_EMPLOYEE = "AUTHENTICATE_EMPLOYEE";

export const setUser = (userInfo) => {
  return async (dispatch) => {
    try {
      dispatch({ type: SET_USER, userInfo });
    } catch (err) {
      dispatch(setAlertModal(true, "error", genericError));
      setTimeout(() => {
        dispatch(setAlertModal(false, ""));
      }, 5000);
    }
  };
};

export const setAgent = (agentInfo) => {
  return async (dispatch) => {
    try {
      dispatch({ type: SET_AGENT, agentInfo });
    } catch (err) {
      dispatch(setAlertModal(true, "error", genericError));
      setTimeout(() => {
        dispatch(setAlertModal(false, ""));
      }, 5000);
    }
  };
};

export const authenticateAgent = (token, agentInfo) => {
  return async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));

      const url = process.env.REACT_APP_API_URL + "/api/user/authenticate";
      const body = {
        AgentAYSUserId: agentInfo.userId,
        key: token,
        AgentCode: agentInfo.agentCode,
        Impersonator: agentInfo.impersonator,
      };

      const response = await axiosInstance.post(url, body, {
        headers: { "content-type": "application/json" },
        withCredentials: true,
      });

      const agent = {
        agentCode: agentInfo.agentCode,
        parentAgentCode: response.data.ParentAgentCode,
        userId: agentInfo.userId,
        userClass: agentInfo.userClass,
        agentName: agentInfo.agentName,
        refreshToken: response.data.RefreshToken,
        impersonator: agentInfo.impersonator,
      };

      sessionStorage.setItem("agent-info", JSON.stringify(agent));
      dispatch(setAgent(agent));
      dispatch({ type: AUTHENTICATE_AGENT, authenticated: true });
    } catch (err) {
      dispatch(setAlertModal(true, "error", genericError));
      window.location.href = getState().app.origin.url;
    }
  };
};

export const authenticateEmployee = (token, agentInfo) => {
  return async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      const url = process.env.REACT_APP_API_URL + "/api/user/authenticateEmp";
      const body = {
        UserId: agentInfo.userId,
        key: token,
        Impersonator: agentInfo.impersonator,
      };

      const response = await axiosInstance.post(url, body, {
        headers: { "content-type": "application/json" },
        withCredentials: true,
      });

      const employee = {
        userId: agentInfo.userId,
        userClass: agentInfo.userClass,
        refreshToken: response.data.RefreshToken,
        impersonator: agentInfo.impersonator,
      };

      //sessionStorage.setItem('agent-info', JSON.stringify(agent));
      sessionStorage.setItem("employee-info", JSON.stringify(employee));
      //where does this affect?

      dispatch(setAgent(employee));
      dispatch({ type: AUTHENTICATE_EMPLOYEE, authenticated: true });
      dispatch(setLoading(false));
    } catch (err) {
      dispatch(setLoading(false));
      dispatch(setAlertModal(true, "error", genericError));
      window.location.href = getState().app.origin.url;
    }
  };
};
